<p-table #mdmChemicalTable [columns]="chemicalHeaders" [value]="masterLists" selectionMode="single"
  [(selection)]="selectedChemical" (onRowSelect)="handleRowSelect($event)">
  <ng-template pTemplate="caption">
    <div class="d-flex flex-row justify-content-between">
      <div>
        <button type="button" pButton icon="pi pi-plus" (click)="handleAddNewChemical()" style="height: 35px;" label="Add"></button>
      </div>
      <div>
        {{title}}
      </div>
      <div>
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input type="text" pInputText size="50" placeholder="Search"
          (input)="mdmChemicalTable.filterGlobal($event.target.value, 'contains')" style="width:auto;height: 32px;">
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <ng-container *ngFor="let chemicalField of columns">
        <ng-template [ngIf]="chemicalField.showInGrid">
          <th id="{{chemicalField.field+'Column'}}" [pSortableColumn]="chemicalField.field == 'lab' ? chemicalField.sort:chemicalField.field">
            {{chemicalField.header}}
            <p-sortIcon [field]="chemicalField.field == 'lab' ? chemicalField.sort:chemicalField.field"></p-sortIcon>
          </th>
        </ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let chemicalCol of columns">
        <ng-template [ngIf]="chemicalCol.showInGrid">
          <td *ngIf="chemicalCol.field != 'lab' && chemicalCol.field != 'active'" class="wrapword">
            {{rowData[chemicalCol.field]}}
          </td>
          <td *ngIf="chemicalCol.field == 'active'">
            <p-checkbox disabled [(ngModel)]="rowData[chemicalCol.field]" binary="true"></p-checkbox>
          </td>
          <td *ngIf="chemicalCol.field=='lab'">
            {{rowData[chemicalCol.field]!= null? rowData[chemicalCol.field].name :''}}
          </td>
        </ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" pButton icon="pi pi-plus" (click)="handleAddNewChemical()" style="height: 35px;" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" [(visible)]="showChemicalDialogue" position="top" [style.width]="'800px'" baseZIndex="10"
  [focusOnShow]="false" showEffect="fade" [modal]="true" (onHide)="this.showChemicalDialogue = false;">
  <div *ngIf="chemical">
    <div *ngFor="let chemicalCol of chemicalHeaders">
      <div class="form-group m-2">
        <div>
          <label>{{chemicalCol.header}}</label>
        </div>
        <div *ngIf="chemicalCol.field == 'chemicalName' ">
          <input pInputText class="form-control" [(ngModel)]="chemical[chemicalCol.field]"
            [ngClass]="{error:chemical[chemicalCol.field+'Error']}" [placeholder]="chemicalCol.header">
        </div>
        <div *ngIf="chemicalCol.field == 'lab'">
          <p-dropdown [options]="_labOptions" [(ngModel)]="chemical[chemicalCol.field]" [filter]="true"
            placeholder="Select Lab" optionLabel="name" [showClear]="true"
            [styleClass]="chemical[chemicalCol.field+'Error']?'error':''"></p-dropdown>
        </div>
        <div *ngIf="chemicalCol.field == 'workFlow'">
          <p-dropdown [options]="workFlowOptions" [(ngModel)]="chemical[chemicalCol.field]" [filter]="true"
            placeholder="Select Workflow" optionLabel="name" [showClear]="true"
            [styleClass]="chemical[chemicalCol.field+'Error']?'error':''"></p-dropdown>
        </div>
        <div *ngIf="chemicalCol.field == 'processStep'">
          <p-dropdown [options]="processStepOptions" [(ngModel)]="chemical[chemicalCol.field]" [filter]="true"
            placeholder="Select Process Step" optionLabel="name" [showClear]="true"
            [styleClass]="chemical[chemicalCol.field+'Error']?'error':''"></p-dropdown>
        </div>
        <div *ngIf="chemicalCol.field == 'description' ">
          <input pInputText class="form-control" [(ngModel)]="chemical[chemicalCol.field]"
            [ngClass]="{error:chemical[chemicalCol.field+'Error']}" [placeholder]="chemicalCol.header">
        </div>
        <div *ngIf="chemicalCol.field == 'active'">
          <p-checkbox [(ngModel)]="chemical[chemicalCol.field]" binary="true"></p-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" pButton icon="pi pi-check" [disabled]="false" (click)="handleSaveOrUpdate()" label="Save"
      style="float: right; height: 35px;"></button>
  </div>
</p-dialog>